import stylesSelect from '../general-components/SelectItem.module.css';
import styles from './Conditional.module.css';

const FieldStrength = ({
    value,
    fieldStrengths,
    onFieldStrengthChange,
}: {
    value: any;
    fieldStrengths: any;
    onFieldStrengthChange: (value: any, checked: boolean) => void;
}) => {
    const isValueArray = Array.isArray(value);
    const handleFieldStrengthChange = (e: any) => {
        onFieldStrengthChange(e.target.value, e.target.checked);
    };
    return (
        <div className={styles.inputWrapper}>
            {fieldStrengths
                ?.filter((f: any) => f !== null)
                .map((f: any) => (
                    <label className={stylesSelect.wrapper} key={f}>
                        <input
                            checked={
                                isValueArray ? value.indexOf(f) > -1 : false
                            }
                            type="checkbox"
                            value={f.toString()}
                            onChange={handleFieldStrengthChange}
                        />
                        <span> {f}</span>
                    </label>
                ))}
        </div>
    );
};

export default FieldStrength;
